var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"user-create-modal","title":_vm.modalTitle,"size":"md","visible":_vm.visible,"hide-footer":true},on:{"hidden":function($event){return _vm.$router.go(-1)}}},[_c('UsersCreateForm',{attrs:{"party":_vm.party}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }